const indexItems = [
  { letter: 'A', title: '娱乐圈爆料', count: 326, desc: '明星八卦、恋情曝光、合约纠纷等娱乐圈最新黑料资讯', icon: 'ri-star-line', color: 'primary' },
  { letter: 'B', title: '网红圈翻车', count: 258, desc: '网红带货假货、人设崩塌、私生活混乱等网红黑料合集', icon: 'ri-emotion-line', color: 'accent' },
  { letter: 'C', title: '综艺黑幕', count: 213, desc: '选秀造假、节目剧本、导师内幕等综艺节目背后的真相', icon: 'ri-tv-line', color: 'secondary' },
  { letter: 'D', title: '影视圈潜规则', count: 187, desc: '导演选角、剧组内幕、行业灰色地带等影视圈深度揭秘', icon: 'ri-film-line', color: 'primary' },
  { letter: 'E', title: '音乐圈抄袭', count: 162, desc: '歌曲抄袭、版权纠纷、原创争议等音乐圈爆料内容汇总', icon: 'ri-music-line', color: 'accent' },
  { letter: 'F', title: '商业代言风波', count: 145, desc: '明星代言翻车、品牌解约、代言费用曝光等商业内幕', icon: 'ri-briefcase-line', color: 'secondary' },
  { letter: 'G', title: '税务问题', count: 131, desc: '明星逃税漏税、税务稽查、补税风波等税务相关黑料', icon: 'ri-file-list-line', color: 'primary' },
  { letter: 'H', title: '私生活曝光', count: 118, desc: '明星私密视频、出轨证据、家庭矛盾等私生活黑料视频', icon: 'ri-lock-unlock-line', color: 'accent' },
  { letter: 'I', title: '平台争议', count: 96, desc: '社交媒体删帖、控评、买热搜等平台操作内幕大揭秘', icon: 'ri-computer-line', color: 'secondary' },
];

const colorStyles: Record<string, { bg: string; iconBg: string; text: string; border: string }> = {
  primary: { bg: 'bg-background-50 border-background-200/60', iconBg: 'bg-primary-100', text: 'text-primary-600', border: 'hover:border-primary-200' },
  accent: { bg: 'bg-background-50 border-background-200/60', iconBg: 'bg-accent-100', text: 'text-accent-600', border: 'hover:border-accent-200' },
  secondary: { bg: 'bg-background-50 border-background-200/60', iconBg: 'bg-secondary-100', text: 'text-secondary-600', border: 'hover:border-secondary-200' },
};

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <span className="w-10 h-10 flex items-center justify-center bg-secondary-500 rounded-lg">
            <i className="ri-book-open-line text-background-50 text-xl"></i>
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">专题索引</h2>
        </div>
        <p className="text-foreground-500 text-sm mb-8 md:mb-10 ml-13">按分类浏览 · 黑料在线完整专题内容导航</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {indexItems.map((item) => {
            const cs = colorStyles[item.color];
            return (
              <a
                key={item.letter}
                href="#media"
                className={`flex items-start gap-4 p-4 rounded-lg border ${cs.bg} ${cs.border} transition-colors cursor-pointer group`}
              >
                <div className={`w-11 h-11 flex items-center justify-center rounded-lg ${cs.iconBg} flex-shrink-0`}>
                  <span className={`font-heading font-bold text-lg ${cs.text}`}>{item.letter}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                      {item.title}
                    </h3>
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{item.count}条</span>
                  </div>
                  <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}